import type { PayerInfo } from '@flywire/internal-react-elements';
import type { SenderFields } from 'domain/recurringReceivables/repository/types';
import { useSelector } from 'react-redux';
import type { RootState } from 'reducers/types';
import { getFieldByEntity, getFieldIdsAndValues } from 'selectors';

export const usePayerInfo = (fields?: SenderFields) => {
  const { ids } = useSelector((state: RootState) =>
    getFieldByEntity(state, 'sender'),
  );
  const senderFields = useSelector((state: RootState) =>
    getFieldIdsAndValues(state, ids),
  );

  let payerInfo: PayerInfo;

  if (fields) {
    const { address1, address2, zip, ...rest } = fields;
    payerInfo = {
      ...rest,
      address: [address1, address2].join(' '),
      zip: zip || '',
    };
  } else {
    payerInfo = {
      address: [
        senderFields.sender_address1 as string,
        senderFields.sender_address2 as string,
      ].join(' '),
      city: senderFields.sender_city as string,
      country: senderFields.sender_country as string,
      email: senderFields.sender_email as string,
      firstName: senderFields.sender_first_name as string,
      lastName: senderFields.sender_last_name as string,
      phone: senderFields.sender_phone as string,
      state: senderFields.sender_state as string,
      zip: (senderFields.sender_zip as string) || '',
    };
  }

  return {
    payerInfo,
  };
};
